export const CARICA_ROUTE =
  process.env.REACT_APP_NODE_ENV === 'local'
    ? '/'
    : '/user/dashboard/addProperty'
export const MODIFICA_ROUTE =
  process.env.REACT_APP_NODE_ENV === 'local'
    ? '/modify/:propertyId'
    : '/:lang/edit/property/:propertyId'
export const MODIFICA_DRAFT_ROUTE =
  process.env.REACT_APP_NODE_ENV === 'local'
    ? '/modify/draft/:draftId'
    : '/:lang/edit/prop/draft/:draftId'

export const CARICA_ROUTE_NEW = '/upload-property/add'
export const MODIFICA_ROUTE_NEW = '/upload-property/:lang/edit/:propertyId'
export const MODIFICA_DRAFT_ROUTE_NEW =
  '/upload-property/:lang/edit-draft/:draftId'
